import React, { useRef, useEffect } from "react";
import styles from "./drop_down_list.module.css";


const DropDownList = ({
  label, showList, setShowList, list, itemName, value, setValue
}) => {

  const inputRef = useRef(null);

  const clickInput = () => {
    setShowList(!showList);
  }

  const handleSelectItem = (item) => {
    setShowList(false);
    if (typeof item === 'object') {
      inputRef.current.value = item.name;
      setValue(item.name);
    } else {
      inputRef.current.value = item;
      setValue(item);
    }
  }

  useEffect(() => {
    inputRef.current.value = value;
  }, [value]);

  return (
    <div className={styles.container}>
      <label htmlFor="last_name" className="label_text">
        {label}
        <input
          type="text"
          id={itemName} name={itemName}
          required={true}
          readOnly
          className="input"
          ref={inputRef}
          onClick={clickInput}
          placeholder="выберите из списка"
        />
      </label>
      {
        showList &&
        <ul className={`${styles.list} ul`}>
          {list.map((item, index) => {
            return (
              <li key={index} className={styles.item} onClick={() => handleSelectItem(item)}>
                {typeof item === 'object' ? item.name : item}
              </li>
            )
          })}
        </ul>
      }
    </div>
  );
}

export default DropDownList;
